const sale = {
  finishOrder: "Tamamla",
  finishedOrder: "已完結",
  unfinishedOrder: "未完結",
  code: "終端客戶編碼",
  name1: "終端客戶名稱1",
  name2: "終端客戶名稱2",
  shortName: "終端客戶簡稱",
  country: "國籍/區域",
  address: "地址",
  zipCode: "郵遞區號",
  email: "Email地址",
  contact: "聯絡人",
  phone: "電話",
  fax: "傳真",
  mobile: "手機",
  account1: "開戶銀行1",
  bank1: "銀行帳號1",
  swiftCode1: "銀行編碼1",
  account2: "開戶銀行2",
  bank2: "銀行帳號2",
  swiftCode2: "銀行編碼2",
  currency: "幣種",
  saleType: "銷售管道",
  creditLevel: "信用等級",
  creditLine: "信用額度",
  depositRate: "定金比例(%)",
  tradeTerm: "貿易條款",
  payMethod: "付款方式",
  commissionRate: "佣金比例",
  org: "分管部門",
  billingDays: "帳期(天)",
  principal: "委託方",
  relatedDocuments: "相關資料(合約/營業執照/開立發票資料)",
  documents: "相關資料",
  affiliates: "關聯公司",
  customerList: "終端客戶清單",
  addCustomer: "添加終端客戶",
  price: "價格",
  shipAddress: "收貨地址",
  shipAddressBook: "收貨地址簿",
  addShipAddress: "新增收貨地址",
  shipAddressName: "收貨方名稱",
  plShipAddressName: "請輸入收貨方名稱",
  shipAddressType: "收貨方類型",
  defaultAddress: "預設地址",
  setDefault: "設為預設地址",
  remark: "備註",
  bySearchShipAddress: "通過收貨方名稱、地址、電話進行搜尋",
  plPrice: "請輸入價格",
  priceMax: "最大值為：{{ num }}",
  priceMin: "最小值為：{{ num }}",
  plProductPrice: "請選擇商品，可輸入存貨名稱與存貨編碼進行蒐索",
  plCustomer: "請選擇終端客戶",
  addPrice: "新增商品價格",
  customerRequired: "終端客戶資料不能為空",
  productRequired: "產品資訊不能為空",
  priceRequired: "價格不能為空",
  product: "商品",
  priceDetail: "價格資訊",
  exitsPrice: "已存在該商品價格",
  productInfo: "商品資訊",
  orderNumber: "銷售訂單號",
  internalNumber: "內部單號",
  receivingUnit: "收貨單位",
  approvalStatus: "審批狀態",
  customerContact: "終端客戶連絡人",
  receivingContact: "收貨聯絡人",
  customerContactPhone: "終端客戶聯絡人電話",
  receivingContactMobile: "收貨聯絡人手機",
  orderType: "銷售類型",
  plOrderType: "請選擇銷售類型",
  taxRate: "稅率（%）",
  quantity: "數量",
  materialStatus: "物料齊料狀態",
  productionStatus: "生產狀態",
  shipmentStatus: "出貨狀態",
  receivingStatus: "終端客戶收貨狀態",
  paymentStatus: "回款狀態",
  receivingAddress: "收貨地址",
  realPrice: "真實價格",
  totalPrice: "總價",
  revisePrice: "調整價格",
  actualPrice: "實際價格",
  orderState: "訂單狀態",
  passed: "已通過",
  notApproval: "待審核",
  plInnerNumber: "請輸入內部單號",
  plReceivingUnit: "請輸入收貨單位",
  plReceivingContact: "請輸入收貨聯絡人",
  plReceivingContactMobile: "請輸入收貨聯絡人手機號碼",
  plReceivingAddress: "請輸入收貨地址",
  orderProduct: "訂單商品",
  plMfgr: "請輸入公司型號",
  plCustomerModel: "請輸入終端客戶型號",
  plProductName: "請輸入商品名稱",
  plReqDeliDate: "請選擇出貨要求時間",
  plSmtStartDate: "請選擇預計上線日期",
  plPreFinishDate: "請選擇預計完工日期",
  plUrgencyLevel: "請輸入緊急程度",
  plSpecialReq: "請輸入特殊要求",
  plReRemark: "請輸入備註",
  plQuantity: "請輸入數量",
  customerShortName: "終端客戶簡稱",
  productCode: "存貨編碼",
  productName: "產品名稱",
  productModel: "產品型號",
  productUom: "主計量單位",
  addOrder: "新增訂單",
  orderSearchTip:
    "通過訂單號、終端客戶簡稱、存貨編碼、終端客戶型號、公司型號、存貨名稱、產品型號、終端客戶編碼、終端客戶名稱1、終端客戶名稱2進行蒐索",
  innerNumber: "內部單號",
  customerModel: "終端客戶型號",
  mfgr: "公司型號",
  reRemark: "備註",
  reqDeliDate: "出貨要求時間",
  smtStartDate: "預計上線日期",
  preFinishDate: "預計完工日期",
  urgencyLevel: "緊急程度",
  specialReq: "特殊要求",
  orderInfo: "訂單資訊",
  customerInfo: "終端客戶資訊",
  proInfo: "產品資訊",
  reportInfo: "報表資料",
  saleTotalQuantity: "需生產總數",
  outPro: "出貨",
  inStock: "入庫",
  dataReportSearch: "通過訂單號、終端客戶資訊、存貨資訊關鍵字進行蒐索",
  notReportData: "暫無報表資料",
  reportSearchTip:
    "通過訂單號、終端客戶編碼、終端客戶簡稱、存貨編碼、存貨名稱進行蒐索",
  addEdit: "新增/編輯生產資料",
  productionSearchTip:
    "通過訂單號、存貨編碼、存貨名稱與終端客戶資訊關鍵字進行蒐索",
  exitsData: "已有當天資料",
  time: "時間",
  updateSuccess: "修改成功",
  history: "歷史明細",
  plCode: "請輸入終端客戶編碼",
  plName1: "請輸入終端客戶名稱1",
  plName2: "請輸入終端客戶名稱2",
  plShortName: "請輸入終端客戶簡稱",
  plAddress: "請輸入終端客戶地址",
  plZipCode: "請輸入終端客戶郵遞區號",
  plEmail: "請輸入終端客戶Email地址",
  plContact: "請輸入聯絡人",
  plPhone: "請輸入終端客戶電話",
  plFax: "請輸入終端客戶傳真",
  plMobile: "請輸入終端客戶手機號碼",
  plBank1: "請輸入銀行帳號1",
  plAccount1: "請輸入開戶銀行1",
  plSwiftCode1: "請輸入銀行編碼1",
  plBank2: "請輸入銀行帳號2",
  plAccount2: "請輸入開戶銀行2",
  plSwiftCode2: "請輸入銀行編碼2",
  plSaleTypes: "請選擇銷售類型",
  plCreditLevels: "請選擇信用等級",
  plCreditLine: "請輸入信用額度",
  plDepositRate: "請輸入定金比例",
  plTradeTerms: "請選擇貿易條款",
  plPaymentMethod: "請選擇付款方式",
  plDictCommissionRate: "請輸入佣金比例",
  plAffiliates: "請輸入關聯公司",
  plBillingDays: "請輸入帳期",
  plPrincipal: "請輸入委託方",
  plTaxRate: "請輸入稅率",
  plOrg: "請選擇組織",
  saleTypeAdd: "新增銷售類型",
  saleTypeDetail: "銷售類型詳情",
  payAdd: "新增付款方式",
  payDetail: "付款方式詳情",
  tradeAdd: "新增貿易條款",
  tradeDetail: "貿易條款詳情",
  codeRequired: "終端客戶編碼必填",
  codeExisted: "終端客戶編碼已存在",
  prevRequired: "請先加完上一條資料",
  bySearchCustomer:
    "通過終端客戶編碼、終端客戶名稱1、終端客戶名稱2、終端客戶簡稱、地址進行蒐索",
  bySearch:
    "通過存貨編碼、存貨名稱、終端客戶編碼、終端客戶名稱1、終端客戶名稱2、終端客戶簡稱、地址進行蒐索",
  bySearchPrice: "通過存貨編碼、存貨名稱、產品型號進行蒐索",
  infoExisted: "該條訊息已存在",
  customerNotExist: "終端客戶資訊不存在或已被刪除",
  estimateDays: "預計到貨天數",
  expiredAt: "過期時間",
  plEstimateDays: "請填寫預計到貨天數",
  plExpiredAt: "請選擇過期時間",
  shippingMethod: "出貨管道",
  plShipping: "請選擇出貨管道",
  customerType: "終端客戶種類",
  plCustomerType: "請選擇終端客戶種類",
  productNotExisted: "請選擇商品",
  orderSuccessProjectError: "訂單資訊修改成功，商品資訊修改失敗",
  projectSuccessOrderError: "商品資訊修改成功，訂單資訊修改失敗",
  productPre: "選擇商品後才可通過審批",
  innerNumberPre: "填寫內部單號才可通過審批",
  passError: "審批未通過",
  passSuccess: "審批通過",
  orderList: "訂單列表",

  taxPrice: "含稅單價",
  plTaxPrice: "請輸入含稅單價",

  addRequirement: "新增評審單",
  requirement: "需求清單",

  notRequirement: "暫未產生需求清單",
  orderDate: "訂單日期",
  selectColumns: "選擇匯出列",
  editOrder: "修改訂單",
  updateErr: "訂單資訊修改失敗",
  exportPI: "匯出PI模版",

  aPrice: "調整價格",
  discount: "優惠/折扣",
  sPrice: "銷售總價",
  send: "備/贈品",
  sendQuantity: "備/贈品數量",
  sendAPrice: "備/贈品調整價格",
  sendDiscount: "備/贈品優惠/折扣",
  sendPrice: "備/贈品總價",
  orderTotal: "訂單總價",
  discountHelp: "最大優惠價格不能大於銷售價(不包含備品)：{{count}}",

  // Excel导出相关
  quotationSheet: "Teklif Formu",
  to: "Alıcı:",
  mov: "Ödeme Koşulu:",
  effectiveDate: "Geçerlilik Tarihi:",
  modelNo: "Model No",
  mfgrNo: "Üretici No",
  picture: "Resim",
  descriptionOfProduct: "Ürün Açıklaması",
  chipSet: "Çip seti",
  package: "Paket (adet/koli)",
  unitPrice: "Birim Fiyat",
  note: "NOT",
  quotationNote1: "1) Yukarıdaki teklif sevkiyattan önce %100 ödeme esaslıdır.",
  quotationNote2: "2) Sipariş değeri 40.000 USD'den az ise, fiyat koşulu EX-WORK olacaktır.",
  quotationNote3: "3) Teklif geçerliliği: Bugünden itibaren 2 HAFTA.",
  quotationNote4: "4) Siparişi peşinat (depozito) ile onaylayın",
  exportFailed: "Dışa aktarma başarısız:",
  quotationTitle: "Teklif Formu",
  contactPerson: "İlgili kişi:",
  officeTel: "Ofis telefonu:",
  emailLabel: "E-posta:",
  date: "Tarih:",
  quotationNumber: "Teklif No:",
  respectedCustomer: "Değerli Müşterimiz",
  quotationIntro: "ZIONCOM Vietnam fabrikasına ilginiz için teşekkür ederiz. Sunduğunuz bilgiler ve doğrudan işbirliği yapma arzunuz doğrultusunda, hizmet teklifimizi ve ilgili fiyat teklifini başvurunuz için sunmaktan mutluluk duyarız.",
  no: "NO",
  quotationProductCode: "Parça No",
  quotationProductDesc: "Açıklama",
  quotationUnit: "Birim",
  quotationCurrency: "Para Birimi",
  moqPrice: "MOQ/ Satın Alma Fiyatı (Vergiler Hariç)",
  attention: "Not:",
  quotationAttention1: "1. Teklif dahil: işçilik maliyeti, lehim pastası ve VSIP II, Binh Duong Eyaleti'ne teslimat.",
  quotationAttention2: "2. Teklif hariç: hammaddeler ve KDV.",
  quotationAttention3: "3. Ödeme koşulları: Ödeme aylık hesaplama yapıldıktan sonra 30 gün içinde yapılmalıdır.",
  quotationAttention4: "4. Minimum Sipariş Miktarı (MOQ): 1000 adet altında MOQ ise, her sipariş için 2.720.000 VND/sipariş kalıp ücreti tahsil edilir",
  customerConfirmation: "Müşteri onayı",
  zioncomVietnam: "Zioncom (Vietnam) Jsc",
  inquiryTemplate: "詢價單模板",
  quotationTemplate: "報價單模板",
  transferOrder: "訂單轉單信息",
  customerPriceTemplate: "客戶價格模版",
  importCustomerPrice: "導入客戶價格",
  swapRes: "轉單結果",
  originSale: "原銷售單",
  orderNo: "訂單號",
  prodOrderNo: "生產訂單號",
  oldCode: "舊料號",
  prodCode: "產品編碼",
  prodName: "產品名稱",
  prodMod: "規格型號",
  count: "數量",
  uom: "單位",
  batch: "批號",
  origin: "部門",
  productor: "物料員",
  confirmer: "品保確認",
  prodManager: "生產主管",
  warehouseer: "倉管員",
  approver: "審核",
  checker: "核准",
  inboundNo: "入庫單號",
  inboundDate: "入庫日期",
  warehouse: "倉庫",
  finishedWarehouse: "成品倉",
  inboundType: "入庫類別",
  prodIn: "產成品入庫單",
  littleTotal: "小記",
  total: "合計",
  notApi: "該客戶沒有配置WmsApi，無法進行轉單！",
  notSale: "該銷售單商品不滿足跑需求單條件，無法進行轉單！",
  saleSwap: "轉銷售單",
  purSwap: "轉採購單",
  purchaseData: "採購數據",
  confirmGeneratePurOrder: "確定生成採購單嗎？",
  notCusPros: "客戶WMS系統中不存在這些物料，請去客戶的WMS系統中先維護這些物料數據",
  notPurProPrice: "客戶WMS系統中不存在這些物料的該供應商的採購價格信息，請先去客戶WMS系統維護相關採購價格信息",
  purSucc: "採購單生成成功",
  onlyOneCustomer: "只允許選擇同一個客戶的銷售單！",
  editOutPl: "可出庫數量已更新，請修改出庫數量",
  bomCopyTip: "該銷售單具有BOM附件，確定需要一併複製BOM附件到新的單據？",
  bomCopyYes: "複製銷售單和BOM附件",
  bomCopyCancel: "僅複製銷售單",
  receiverFax: "收貨人傳真",
  receiverPhone: "收貨人電話",
  licenseId: "統一編號",
  licenseAddress: "營業證登記地址",
  invoiceNumber: "開票號碼",
  invoiceAddress: "發票寄送地址",
  printDate: "製表日期",
  printPageNo: "頁次",
  domesticSaleOrder: "國內銷貨單",
  printSaleNo: "銷貨單號",
  printCustomerName: "客戶全名",
  printUnifiedTitle: "統一編號",
  printOrderDate: "單據日期",
  printSendAddress: "送貨地址",
  printPhone: "聯絡電話",
  printInvoiceNumber: "發票號碼",
  printInvoiceAddress: "發票地址",
  printContact: "聯絡人",
  printRemark: "備註",
  printSeq: "序號",
  printProductName: "品名",
  printQuantity: "銷貨數量",
  printBQuantity: "贈/備品量",
  printUom: "單位",
  printPrice: "單價",
  printAmount: "金額",
  onlyOneSelectip: "請選擇一條單據",
  printSale: "打印銷貨單",
  printTotalQuantity: "數量合計",
  printSaleAmount: "本幣銷貨金額",
  printSaleTax: "本幣銷貨稅額",
  printTotalAmount: "本幣金額合計",
  orderPrintLeft: "簽收後，請交貨人員捎回或傳真回：{{fax}}，謝謝！！",
  orderPrintRight: "自存聯（白） 會計聯（藍） 簽收聯（紅） 客戶聯（黃）",
  printApprove: "核准",
  printWarehouse: "倉庫",
  printSales: "業務",
  printMaker: "製單",
  printCustomerSign: "客戶簽收",
  toOfficial: "轉正式訂單",
  toOfficialConfirm: "確定將選中的 {{count}} 個訂單轉為正式訂單嗎？",
  toOfficialSingleConfirm: "確定轉為正式訂單？",
  toOfficialSuccess: "轉正式訂單成功",
  toOfficialError: "以下訂單轉正式訂單失敗",
  toOfficialHasRequirement: "以下訂單已有需求清單，不能轉正式訂單",
};

export default sale;
